<template>
  <!-- 会员管理 -->
  <div class="viewContainer">
    <!--工具条-->
    <div class="main_container" v-if="showList">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
      </div>
      <!-- 顶部搜索框 -->
      <el-collapse-transition>
        <div v-show="show3">
          <el-form class="findform" :model="filters">
            <el-form-item label="手机号：" style="display:flex;width:30%">
              <el-input v-model="filters.phone" placeholder="请输入手机号" maxlength="11"
                onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')" style="width:90%" />
            </el-form-item>
            <el-form-item label="所属城市：" style="display:flex;width:30%;">
              <el-cascader v-model="filters.chengshi" placeholder="请选择城市" :options="options" style="width:90%"
                filterable clearable @change="handleChange" />
            </el-form-item>
            <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <!-- 列表区域 -->
    <div class="main_container" v-if="showList">
      <section class="model_section">
        <p class="model_top_title">邀请人变更</p>
      </section>

      <div class="table_container">
        <el-table :data="dataList" stripe border>
          <el-table-column label="序号" align="center" width="68px">
            <template scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column label="手机号" align="center">
            <template scope="scope">
              <span :title="scope.row.phone">{{ scope.row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属城市" align="center">
            <template scope="scope">
              <span :title="scope.row.scname">{{ scope.row.pname }}{{ scope.row.cname }}{{ scope.row.scname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="二级创客数量" align="center">
            <template scope="scope">
              <span :title="scope.row.invitecount">{{ scope.row.invitecount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否是创客" align="center">
            <template scope="scope">
              <span>{{ scope.row.ismaker==1?'是':'否' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center">
            <template scope="scope">
              <span :title="scope.row.createtime">{{ scope.row.createtime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template scope="scope">
              <span class="handle" @click="editDetails(scope)"> <i class="el-icon-edit-outline"></i> 变更邀请人 </span>
              <span class="handle" @click="seeDetails(scope)"> <i class="el-icon-view"></i> 查看 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
          :current-page="pageIndex" :total="total" style="float:right;margin:10px 0;" />
      </div>
    </div>

    <div v-if="!showList">
      <!-- <div class="main_container">
        <el-form style="padding:10px;display:flex;">
          <el-form-item style="display:flex;width:30%">
            <el-input v-model="keyWordTwo" placeholder="搜索变更人手机号" maxlength="11"
              onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')" style="width:90%;" />
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmitTwo">查询</el-button> </el-form-item>
        </el-form>
        <p class="reminder" style="margin-left: 16px;padding-bottom:10px;">
          已选变更人: &nbsp; &nbsp; {{ Object.keys(dataOne).length !== 0 ? '用户id ' : '' }}{{ dataOne.userid }} &nbsp; &nbsp;
          {{Object.keys(dataOne).length !== 0 ? '手机号 ' : '' }}{{ dataOne.phone }}
          <span style="color: red; margin-left: 10px; cursor: pointer;" v-if="Object.keys(dataOne).length !== 0"
            @click="dataOne = {}">删除</span>
        </p>
      </div> -->

      <div class="main_container">
        <section class="model_section">
          <p class="model_top_title">二级创客列表</p>
          <el-button type="danger" @click="changeInviter()" style="float: right;margin: 5px 10px 0 0;"
            v-show="dataListTwo.length>0">批量变更邀请人</el-button>
        </section>
        <div class="table_container">
          <el-table :data="dataListTwo" ref="multipleTable" stripe border @selection-change="handleSelectionChange"
            @row-click="handleRowClick">
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column label="序号" align="center" width="50">
              <template scope="scope"> <span>{{ scope.$index + 1 }}</span> </template>
            </el-table-column>
            <el-table-column label="手机号" align="center">
              <template scope="scope">
                <span :title="scope.row.phone">{{ scope.row.phone }}</span>
              </template>
            </el-table-column>
            <el-table-column label="归属城市" align="center">
              <template scope="scope">
                <span :title="scope.row.scname">{{ scope.row.pname }}{{ scope.row.cname }}{{ scope.row.scname }}</span>
              </template>
            </el-table-column>
            <el-table-column label="二级创客数量" align="center">
              <template scope="scope">
                <span :title="scope.row.invitecount">{{ scope.row.invitecount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="是否是创客" align="center">
              <template scope="scope">
                <span>{{ scope.row.ismaker == 1 ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" align="center">
              <template scope="scope">
                <span :title="scope.row.createtime">{{ scope.row.createtime }}</span>
              </template>
            </el-table-column>
          </el-table>
          <!--分页-->
          <el-pagination layout="prev, pager, next" @current-change="handleCurrentChangeTwo"
            :current-page="pageIndexTwo" :page-size="10" :total="totalTwo" style="margin:10px 0;float:right" />
        </div>
        <div style="width: 100%;text-align: center;margin-bottom: 20px;display: flow-root;"><el-button
            @click="returnFun">返回</el-button></div>
      </div>
    </div>

    <!-- 新增/编辑推广-弹框 -->
    <el-dialog title="变更邀请人" :visible.sync="isToExamine" :center="true" class="add_order_cancle" width="30%">
      <el-form>
        <el-form style="padding:10px;display:flex;">
          <el-form-item style="display:flex;width:80%">
            <el-input v-model="keyWordTwo" placeholder="搜索变更人手机号" maxlength="11" onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')" style="width:90%;" />
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmitTwo">查询</el-button> </el-form-item>
        </el-form>
        <p class="reminder" style="margin-left: 16px;padding-bottom:10px;">
          已选变更人: &nbsp; &nbsp; {{ Object.keys(dataOne).length !== 0 ?'用户id ':''}}{{ dataOne.userid }} &nbsp; &nbsp; {{
          Object.keys(dataOne).length !== 0 ? '手机号 ' : '' }}{{ dataOne.phone }}
          <span style="color: red; margin-left: 10px; cursor: pointer;" v-if="Object.keys(dataOne).length !== 0"
            @click="dataOne={}">删除</span>
        </p>
      </el-form>
      <!-- 弹框按钮 确定/取消 -->
      <div style="text-align:center">
        <el-button @click="cencalFun">取消</el-button>
        <el-button type="danger" @click="editSubmit()">保存</el-button>
      </div>
    </el-dialog>


  </div>
</template>
<script>
import { invitergetlist, getmakerinfo, inviterchange } from "../../api/shopWindow";
import { provincegetcountys } from '../../api/newOss';
import alertTrends from '../../common/alertTrends.js';
export default {
  name: "MemberList",
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      cardId: "",
      dataList: [], // 查询列表
      pageIndex: 1,
      total: 0,


      totalTwo: 0,
      pageIndexTwo: 1,
      dataListTwo: [],
      keyWordTwo: '',     //搜索关键字
      options: [],
      provinceId: 0, // 省id
      cityId: 0, // 市id
      zoneId: 0, // 区县
      userid: 0,  //点击查看的用户id
      dataOne: {},  //获取创客信息-点击查询
      userids: [], //变更用户邀请人用户ID集合

      filters: {
        phone:'',
        chengshi:'',
      },
      isToExamine: false, //变更邀请人 弹框


      showList: true, // 初始第一页列表，false显示查看列表
    };
  },
  methods: {
    // 查询列表
    getlist(userid) {
      var obj = {
        phone: userid ?'':this.filters.phone,
        pid: userid ?'':this.provinceId,
        cid: userid ?'':this.cityId,
        scid: userid ?'':this.zoneId,
        inviterid: userid||0,
        page: userid ? this.pageIndexTwo : this.pageIndex,
        size: 10
      };
      invitergetlist(obj).then(data => {
        if (!userid){
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.list;
            this.total = data.resultObj.totalcount;
          } else {
            this.dataList = []
            this.total = 0
          }
        } else {
          if (data.resultCode == 1) {
            this.dataListTwo = data.resultObj.list;
            this.totalTwo = data.resultObj.totalcount;
          } else {
            this.dataListTwo = []
            this.totalTwo = 0;
          }
        }
      });
    },
    // 变更邀请人
    editDetails(scope) {
      this.isToExamine = true;
      this.userid = scope.row.userid;
    },
    // 查看
    seeDetails(scope) {
      this.showList = false;
      this.pageIndexTwo = 1;
      this.dataListTwo = [];
      this.userid = scope.row.userid;
      this.getlist(scope.row.userid)

      this.dataOne = {};
      this.keyWordTwo = '';
      this.userids = [];

    },
    editSubmit(){
      if (Object.keys(this.dataOne).length === 0) {
        this.showAlert('请输入变更邀请人手机号并查询');
        return false
      }
      if (this.showList){ //一级列表页面的变更邀请人
        this.userids = [this.userid];
      }
      this.inviterchangeFun()
    },
    // 调用用户邀请人接口
    inviterchangeFun(){
      var obj = {
        inviterid: this.dataOne.userid, //变更的邀请人ID
        userids: this.userids, //用户ID集合
      };
      inviterchange(obj).then(data => {
        if (data.resultCode == 1) {
          this.dataOne = {};
          this.userids = [];
          this.keyWordTwo = '';
          this.isToExamine = false;
          this.$swal({
            type: "success",
            text: "变更邀请人 操作成功",
          });

          if (!this.showList){
            this.$refs.multipleTable.clearSelection();
          }
        }
      });
    },
    // 点击返回按钮
    returnFun() {
      this.showList = true;
    },
    //搜索手机号
    onSubmitTwo() {
      if (this.keyWordTwo.length === 0) {
        this.showAlert('请输入变更邀请人手机号');
        return false
      }
      if (this.keyWordTwo.length != 11) {
        this.showAlert('请输入正确变更邀请人手机号');
        return false
      }
      var obj = {
        phone: this.keyWordTwo,
      };
      getmakerinfo(obj).then(data => {
        if (data.resultCode==1){
          this.dataOne = data.resultObj;
        } else {
          this.showAlert('用户不存在或不是创客，请检查');
        }
      });

    },
    // 取消
    cencalFun(){
      this.keyWordTwo = '';
      this.isToExamine = false;
      this.dataOne = {}
    },
    

    //点击复选框
    handleSelectionChange(val) {
      this.userids = [];
      val.forEach((element) => {
        this.userids.push(element.userid);
      });
    },
    // 点击整行勾选
    handleRowClick(row) {
      // 切换当前行的选中状态
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    // 二级列表页面，变更邀请人按钮
    changeInviter(){
      if (this.userids.length==0){
        this.showAlert('请先在列表勾选需要变更邀请人的数据');
        return false
      }
      this.isToExamine = true;
    },


    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getlist();
    },

    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getlist();
    },
    // 分页2
    handleCurrentChangeTwo(val) {
      this.pageIndexTwo = val;
      this.getlist(this.userid)
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
      this.zoneId = val[2]; // 区
    },
    // 查找省市
    getprovince() {
      var loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          if (item.citys && item.citys.length > 0) {
            item.citys.forEach(city => {
              const allCityOption = { value: 0, label: "全市" };
              // const allCityOption = {};
              let cityObj;
              if (city.countys && city.countys.length > 0) {
                cityObj = {
                  value: city.cid, label: city.cname,
                  children: [allCityOption].concat(city.countys.map(zone => ({
                    value: zone.scid, label: zone.scname
                  })))
                };
              } else {
                cityObj = { value: city.cid, label: city.cname, children: [allCityOption] };
              }
              province.children.push(cityObj);
            });
          } else { delete province.children; }
          provinceOptions.push(province);
        });
        this.options = provinceOptions;
        // this.options.unshift({ value: 0, label: "全国" });
      })
    },

    // 重置
    fnReset() {
      this.filters = {
        phone: "",
        chengshi: '', // 所属城市
      },
      this.provinceId = 0;
      this.cityId = 0; // 所属城市-市id
      this.zoneId = 0;
      // this.pageIndex = 1;
      // this.getusermanager();
    },


  },
  mounted() {
    this.getlist();
  },
  created() {
    this.getprovince(); // 所属城市
  }
}
</script>
<style scoped>
.member_watch {
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  padding-bottom: 5%;
}

.member_watch_div {
  width: 80%;
  margin: 20px 0 0 10px;
  padding: 15px 0 0 15px;
}

.cooperative_brand {
  width: 100%;
  height: 30px;
  line-height: 30px;
}

.info {
  font-size: 18px;
  font-weight: 700;
  float: left;
}

.operation_button {
  float: right;
}

.ban_tab {
  margin-bottom: 20px;
}

.preservation_div {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}

.dialogForm {
  width: 100%;
  margin: 0 auto;
  padding-bottom: 10px;
  padding-left: 10%;
}
</style>


// WEBPACK FOOTER //
// inviterchange.vue?15e81272